import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BASE}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("dg_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const resolveImg = (url) => {
  if (!url) return "";
  if (url.startsWith("/api/")) return `${BASE}${url}`;
  return url;
};

// ---- Auth ----
export const apiRegister = (data) => client.post("/auth/register", data).then((r) => r.data);
export const apiLogin = (data) => client.post("/auth/login", data).then((r) => r.data);
export const apiMe = () => client.get("/auth/me").then((r) => r.data);
export const apiUpdateProfile = (data) => client.put("/auth/profile", data).then((r) => r.data);

// ---- Address Book ----
export const apiGetAddresses = () => client.get("/auth/addresses").then((r) => r.data);
export const apiAddAddress = (data) => client.post("/auth/addresses", data).then((r) => r.data);
export const apiUpdateAddress = (id, data) => client.put(`/auth/addresses/${id}`, data).then((r) => r.data);
export const apiDeleteAddress = (id) => client.delete(`/auth/addresses/${id}`).then((r) => r.data);
export const apiSetDefaultAddress = (id) => client.put(`/auth/addresses/${id}/default`).then((r) => r.data);

// ---- Products ----
export const apiGetProducts = (params = {}) =>
  client.get("/products", { params }).then((r) => r.data);
export const apiGetProduct = (slug) => client.get(`/products/${slug}`).then((r) => r.data);
export const apiCreateProduct = (data) => client.post("/products", data).then((r) => r.data);
export const apiUpdateProduct = (id, data) => client.put(`/products/${id}`, data).then((r) => r.data);
export const apiDeleteProduct = (id) => client.delete(`/products/${id}`).then((r) => r.data);

// ---- Orders ----
export const apiCreateOrder = (data) => client.post("/orders", data).then((r) => r.data);
export const apiGetOrders = () => client.get("/orders").then((r) => r.data);
export const apiGetMyOrders = () => client.get("/orders/my").then((r) => r.data);
export const apiUpdateOrderStatus = (id, status) =>
  client.put(`/orders/${id}/status`, { status }).then((r) => r.data);

// ---- Coupons ----
export const apiValidateCoupon = (code, subtotal) =>
  client.post("/coupons/validate", { code, subtotal }).then((r) => r.data);
export const apiGetCoupons = () => client.get("/coupons").then((r) => r.data);
export const apiCreateCoupon = (data) => client.post("/coupons", data).then((r) => r.data);
export const apiDeleteCoupon = (id) => client.delete(`/coupons/${id}`).then((r) => r.data);

// ---- Banners ----
export const apiGetBanners = () => client.get("/banners").then((r) => r.data);
export const apiGetAllBanners = () => client.get("/banners/all").then((r) => r.data);
export const apiCreateBanner = (data) => client.post("/banners", data).then((r) => r.data);
export const apiUpdateBanner = (id, data) => client.put(`/banners/${id}`, data).then((r) => r.data);
export const apiDeleteBanner = (id) => client.delete(`/banners/${id}`).then((r) => r.data);

// ---- Admin ----
export const apiGetStats = () => client.get("/admin/stats").then((r) => r.data);
export const apiGetLowStockProducts = () => client.get("/admin/low-stock").then((r) => r.data);
export const apiGetCustomers = () => client.get("/customers").then((r) => r.data);

// ---- Razorpay Payments ----
export const apiCreateRazorpayOrder = (amount) =>
  client.post("/razorpay/create-order", { amount }).then((r) => r.data);
export const apiVerifyRazorpayPayment = (data) =>
  client.post("/razorpay/verify", data).then((r) => r.data);

// ---- Store Settings (UPI QR etc.) ----
export const apiGetSettings = () => client.get("/settings").then((r) => r.data);
export const apiUpdateSettings = (data) => client.put("/admin/settings", data).then((r) => r.data);
export const apiUpload = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return client.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};

export default client;
